import React from 'react'
import { FiCheck } from 'react-icons/fi'

interface ProgressIndicatorProps {
  currentStep: number
  totalSteps: number
  stepLabels?: string[]
}

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentStep,
  totalSteps,
  stepLabels = []
}) => {
  // Shorten labels to ensure single-line display
  const shortenLabel = (label: string): string => {
    const shortened: Record<string, string> = {
      'Basic Setup': 'Setup',
      'Landing page': 'Landing',
      'Select package': 'Package'
    }
    return shortened[label] || label
  }

  return (
    <div className="w-full py-3">
      <div className="flex justify-between items-center w-full relative">
        {/* Progress line - background */}
        <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gray-200 z-0" />

        {/* Progress line - filled (thicker for active step emphasis) */}
        <div
          className="absolute top-1/2 left-0 h-1 bg-brand-500 z-10 transition-all duration-300"
          style={{
            width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%`
          }}
        />

        {/* Step indicators */}
        {Array.from({ length: totalSteps }).map((_, index) => {
          const step = index + 1
          const isCompleted = step < currentStep
          const isCurrent = step === currentStep
          const originalLabel = stepLabels[index] || `Step ${step}`
          const label = shortenLabel(originalLabel)

          return (
            <div
              key={step}
              className="relative z-20 flex-1 flex flex-col items-center gap-1.5"
            >
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center font-bold border-2 transition-all
                  ${isCompleted || isCurrent
                    ? 'bg-brand-500 text-white'
                    : 'bg-gray-200 text-gray-500'
                  }
                  ${isCurrent
                    ? 'border-brand-600 shadow-lg scale-110'
                    : 'border-transparent'
                  }
                `}
              >
                {isCompleted ? (
                  <FiCheck size={20} />
                ) : (
                  <span className="text-sm">{step}</span>
                )}
              </div>
              {label && (
                <p
                  className={`
                    text-xs text-center whitespace-nowrap font-medium
                    ${isCurrent
                      ? 'text-brand-700 font-bold'
                      : 'text-gray-600'
                    }
                  `}
                  style={{ minHeight: '1rem' }}
                >
                  {label}
                </p>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}







